import { createFileRoute } from '@tanstack/react-router';

import { AnalysisPage } from '@features/game/pages/AnalysisPage';
import { UserAuthMenuWidget } from '@features/user/ui/UserAuthMenu/UserAuthMenuWidget';
import { UserSettingsMenuWidget } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuWidget';

export const Route = createFileRoute('/game/analysis')({
  component: Page,
});

function Page() {
  return (
    <AnalysisPage
      avatar={
        <>
          <UserSettingsMenuWidget />
          <UserAuthMenuWidget alwaysRound />
        </>
      }
    />
  );
}
